import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.instagram.com/whovipinsaini/"
        className="home__social-icon"
        target="__blank"
      >
        <i class="uil uil-instagram"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/vipinsaini21/"
        className="home__social-icon"
        target="__blank"
      >
        <i class="uil uil-linkedin"></i>
      </a>
      <a
        href="https://github.com/vipinsaini21"
        className="home__social-icon"
        target="__blank"
      >
        <i class="uil uil-github-alt"></i>
      </a>
    </div>
  );
};

export default Social;
